/* eslint-disable */
import { ENV } from '../../web/constants/env'

let resolve

const p = new Promise(r => {
  resolve = r
})

global.fbAsyncInit = function () {
  FB.init({
    appId: ENV.FB_APP_ID,
    status: true,
    xfbml: false,
    version: 'v13.0'
  })
  resolve(FB)
}
;(function (d, s, id) {
  let js
  const fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s)
  js.id = id
  js.src = '//connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

!(function (f, b, e, v, n, t, s) {
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = !0
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

fbq('init', '2087638994684850')

export const fetchSDK = function () {
  return Promise.resolve(p)
}
